// extracted by mini-css-extract-plugin
module.exports = {"card":"style_card__3768e","cardHeading":"style_cardHeading__3DC9Z"};